module.exports = __webpack_public_path__ + "static/media/speaker-on.fbb3810b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/player-controls/speaker-on.svg
// module id = 605
// module chunks = 0